const pathToAuth = () => {
    return `${process.env.REACT_APP_DOMAIN_ACCOUNTS}/auth?app_key=${process.env.REACT_APP_APPLICATION_UID}&redirect_url=${window.location.href}`;
};
export default pathToAuth;
